import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, GithubAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { gcpProjectId, firebaseApiKey, firebaseAuthDomain, logVerbose, isLocal } from './config';

// Public configuration object
const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: gcpProjectId,
};

if (firebaseApiKey && firebaseAuthDomain && gcpProjectId) {
  if (logVerbose) console.debug(`Firebase configured for project ${gcpProjectId}`);
} else {
  throw new Error(`Missing firebase configuration parameter(s)`);
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
if (isLocal) {
  // Use the default Firebase Auth Emulator endpoint
  console.warn(`Vue app connecting to local Firebase Auth Emulator (Port 9099)`);
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
}

export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();
